<template>
  <div>
    <section class="hero hero-atlantico is-bold">
      <div class="container">
        <div class="hero-body">
          <h1 class="title">{{ $route.query.title }} album</h1>
          <p>Click any of the thumbnail pictures to open the photo viewer</p>
        </div>
      </div>
    </section>
    <div class="container">
      <router-link to="/photos"><span>&larr;</span> See All Albums</router-link>
      <Photoswipe :options="options">
        <img v-for="(photo, index) in photos" :src="backend_url + photo.path_lg" :key="index" :data-pswp-src="backend_url + photo.path_lg">
      </Photoswipe>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { setAuthHeader } from '../axios_auth'
export default {
  data () {
    return {
      options: {
        bgOpacity: 0.9,
        shareEl: false
      },
      album: this.$route.params.album,
      albumTitle: '',
      photos: []
    }
  },
  computed: {
    backend_url: function () {
      return this.$store.getters.backend_url
    }
  },
  created () {
    setAuthHeader(localStorage.getItem('backendToken'))
    axios.get('/api/getphotos/' + this.album)
      .then(response => {
        this.photos = response.data
        if (this.$mq !== 'desktop') {
          this.photos.forEach(function (photo) {
            if (photo.path_sm) {
              photo.path_lg = photo.path_sm
            }
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  beforeRouteLeave (to, from, next) {
    // trick to remove the photoswipe modal when a backbutton is used
    var pswp = document.getElementsByClassName('pswp')[0]
    if (pswp.getAttribute('aria-hidden') === 'false') {
      // if photoswipe modal is active, close it and cancel back navigation
      document.getElementsByClassName('pswp__button--close')[0].click()
      next(false)
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
  .container img {
    width: 10rem;
    margin: 1rem;

    &:hover {
      cursor: pointer;
    }
  }

  .container a {
    margin-left: 1rem;
    font-size: .9rem;

    @media screen and (max-width: 1023px) {
      font-size: 1.2rem;
    }

    span {
      font-size: 1.2rem;

      @media screen and (max-width: 1023px) {
        font-size: 1.5rem;
      }
    }
  }
</style>
